import React from 'react';

import ModalBox from '../../shared/modal';
import { getCookie, setCookie } from '../../../../shared/js/cookie';
import './converter-popup.less';
import CloseIcon from '../../../apps/everad/assets/img/shared/icon-close-black.svg';

const isEverad = process.env.CPA_ENV === 'everad';

class Popup extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.closePopup = this.closePopup.bind(this);
	}
	closePopup() {
		setCookie('was_ro_popup_shown', 'true', 3 * 24);
		this.setState({});//trigger rerender
	}
	render() {
		const {  props } = this;
		const  isRoPopupVisible = props.appConfig && props.appConfig.isRoPopupVisible;
		const isNotificationPopupVisible = !getCookie('was_ro_popup_shown') && isEverad && isRoPopupVisible;

		return (
			<div>
				<ModalBox
					className='modal-overlay__content no-close-cross location-banner-popup-container'
					body={ModalBody({ language: props.intl.language, closePopup: this.closePopup })}
					isOpen={isNotificationPopupVisible}
				/>
			</div>
		);
	}
}

const ModalBody = props => {
	return (
		<div className="converter-popup">
			<div className={`location-banner location-banner-${props.language}`}>
				<img
					src={CloseIcon}
					className="close-image"
					onClick={props.closePopup}
				/>
			</div>
		</div>
	);
};

export default Popup;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/converter-popup.js